import { Navigate, useLocation, useParams } from 'react-router-dom';

import { ConceptGroupDraftReview } from '../containers/ConceptGroupDraftReview';
import { useConceptGroupPreviewPage } from '../hooks/useConceptGroupPreviewPage';

/**
 * Legacy ``/concept-group-preview/:previewId`` route entry. Once the draft's
 * stable catalog id is known (minted at save under the new workflow), this
 * URL forwards to the canonical asset route, which renders the SAME review
 * surface ({@link ConceptGroupDraftReview}) while Draft. Pre-stable-id (legacy)
 * previews keep rendering here; the confirmed redirect inside the model still
 * handles Draft→Ready.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const ProjectConceptGroupPreviewPage = () => {
  const { projectId = '', previewId = '' } = useParams<{ projectId: string; previewId: string }>();
  const location = useLocation();
  const model = useConceptGroupPreviewPage({ previewId, projectId });
  const conceptGroupId = model.createdGroupId;
  if (conceptGroupId && !model.isConfirmed) {
    return (
      <Navigate
        to={`/projects/${projectId}/concept-group/${conceptGroupId}${location.search}`}
        replace
      />
    );
  }
  return <ConceptGroupDraftReview previewId={previewId} projectId={projectId} />;
};
